(function() {
  'use strict';

  // Read customer segment from meta tags
  var segmentMeta = document.querySelector('meta[name="customer-segment"]');
  var loggedInMeta = document.querySelector('meta[name="customer-logged-in"]');

  if (!segmentMeta) return;

  var segment = segmentMeta.getAttribute('content');
  var isLoggedIn = loggedInMeta ? loggedInMeta.getAttribute('content') === 'true' : false;

  // Only apply pricing for discount segments
  var multipliers = {
    'standard': 0.50,
    'distributor': 0.44,
    'amsterdam': 0.43
  };

  var multiplier = multipliers[segment];

  // If no multiplier (guest or regular), do nothing
  if (!multiplier) return;

  // Format price as currency (cents to dollars)
  function formatMoney(cents) {
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2);
  }

  // Get variants data from embedded JSON
  function getVariantsData() {
    var el = document.querySelector('[data-id="product-variants"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch(e) {
      return null;
    }
  }

  // Update displayed price elements
  function updatePriceDisplay(priceInCents) {
    var formatted = formatMoney(priceInCents);
    // Update all price display elements
    var priceEls = document.querySelectorAll('.price__current, [data-customer-price]');
    priceEls.forEach(function(el) {
      el.textContent = formatted;
    });
  }

  // Calculate customer price from base price
  function calcCustomerPrice(regularPriceInCents) {
    return regularPriceInCents - Math.floor(regularPriceInCents * multiplier);
  }

  // Handle variant change
  function onVariantChange(variantId) {
    var variants = getVariantsData();
    if (!variants) return;

    var variant = variants.find(function(v) { return v.id == variantId; });
    if (!variant) return;

    var regularPrice = variant.price;
    var customerPrice = calcCustomerPrice(regularPrice);
    updatePriceDisplay(customerPrice);
  }

  // Listen for variant changes
  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      onVariantChange(e.detail.variant.id);
    }
  });

  // Also listen for form select/radio changes
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('change', function(e) {
      var selected = form.querySelector('[name="id"]:checked, [name="id"] option:checked, input[name="id"]');
      if (selected && selected.value) {
        onVariantChange(selected.value);
      }
    });
  });

  // Apply pricing on page load for current variant
  document.addEventListener('DOMContentLoaded', function() {
    var idInput = document.querySelector('input[name="id"], select[name="id"]');
    if (idInput && idInput.value) {
      onVariantChange(idInput.value);
    }
  });

})();